export default {
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'vs BGG'
    },
    unique: [],
    sort: 'rating.gap',
    lang: {
        views: ['list', 'sheet', 'grid'],
        name: 'Rating Disparity',
        category: ['User', 'Ratings'],
        description: 'Rating disparity against the community for the game.',
    },
    filters: ['rating.disparity']
}